import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import I18n from '@utils/i18n';
import { exportDeficienciesPath } from 'routes';

function ExportCsvButton({ deficiencyIds, disabled, queryParams }) {
  const onExport = useCallback(() => {
    let url = exportDeficienciesPath();
    let params = new URLSearchParams();

    if (deficiencyIds) {
      const idsArray = deficiencyIds.split(',');
      idsArray.forEach((id) => params.append('ids[]', id.trim()));
      params = params.toString();
    } else {
      params = new URLSearchParams(queryParams);
      params.append('all', 'true');
    }

    if (params.toString()) {
      url += `?${params}`;
    }

    window.location.href = url;
  }, [deficiencyIds, queryParams]);

  return (
    <button type="button" tabIndex="0" className="qmb-control" disabled={disabled} onClick={onExport}>
      <i className="fa-light fa-file-export" />
      {I18n.t('features.deficiencies_index.export_csv')}
    </button>
  );
}

ExportCsvButton.propTypes = {
  deficiencyIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  queryParams: PropTypes.object.isRequired
};

ExportCsvButton.defaultProps = {
  deficiencyIds: null
};

export default ExportCsvButton;
